import { useState } from 'react';
import useFetchWithMsal from '../useFetchWithMsal';
import { protectedResources } from '../../authConfig';

const useAllocationDateRanges = () => {
    const [dateRanges, setDateRanges] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { execute } = useFetchWithMsal({
        scopes: protectedResources.apiScopes.scopes.read,
    });

    const refreshRanges = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await execute(
                "GET",
                `${process.env.REACT_APP_BACKEND_BASE_URL}/api/allocation-date-ranges`
            );
            
            if (response.success) {
                setDateRanges(response.data.dateRanges || []);
            } else {
                setError(response.message || 'שגיאה בטעינת הנתונים');
            }
        } catch (err) {
            console.error('Error fetching date ranges:', err);
            setError('שגיאה בחיבור לשרת');
        } finally {
            setLoading(false);
        }
    };

    // הוספת טווח חדש
    const addRange = async (newRangeData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await execute(
                "POST",
                `${process.env.REACT_APP_BACKEND_BASE_URL}/api/allocation-date-ranges`,
                newRangeData
            );
            
            if (response.success) {
                await refreshRanges(); 
                return true;
            } else {
                setError(response.message || 'שגיאה בהוספת הטווח');
                return false;
            }
        } catch (err) {
            console.error('Error adding date range:', err);
            setError('שגיאה בחיבור לשרת');
            return false;
        } finally {
            setLoading(false);
        }
    };

    const updateRange = async (rangeId, updateData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await execute(
                "PUT",
                `${process.env.REACT_APP_BACKEND_BASE_URL}/api/allocation-date-ranges/${rangeId}`,
                updateData
            );
            
            if (response.success) {
                await refreshRanges(); 
                return true;
            } else {
                setError(response.message || 'שגיאה בעדכון הטווח');
                return false;
            }
        } catch (err) {
            console.error('Error updating date range:', err);
            setError('שגיאה בחיבור לשרת');
            return false;
        } finally {
            setLoading(false);
        }
    };

    const deleteRange = async (rangeId) => {
        setLoading(true);
        setError(null);
        try {
            const response = await execute(
                "DELETE",
                `${process.env.REACT_APP_BACKEND_BASE_URL}/api/allocation-date-ranges/${rangeId}`
            );
            
            if (response.success) {
                await refreshRanges(); 
                return true;
            } else {
                setError(response.message || 'שגיאה במחיקת הטווח');
                return false;
            }
        } catch (err) {
            console.error('Error deleting date range:', err);
            setError('שגיאה בחיבור לשרת');
            return false;
        } finally {
            setLoading(false);
        }
    };

    return {
        dateRanges,
        loading,
        error,
        refreshRanges,
        addRange,
        updateRange,
        deleteRange
    };
};

export default useAllocationDateRanges;